import { render, staticRenderFns } from "./NewsEvents.vue?vue&type=template&id=ce25cc40&scoped=true&"
import script from "./NewsEvents.vue?vue&type=script&lang=js&"
export * from "./NewsEvents.vue?vue&type=script&lang=js&"
import style0 from "./NewsEvents.vue?vue&type=style&index=0&id=ce25cc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce25cc40",
  null
  
)

export default component.exports